import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import axios from 'axios';
import API_BASE_URL from '../../services/api';

/**
 * Tampon public affiché en bas des pages légales : date de dernière vérification
 * de conformité (mise à jour automatiquement chaque mois selon le droit français).
 */
const LegalComplianceStamp = () => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    let active = true;
    axios.get(`${API_BASE_URL}/api/legal/compliance/latest`)
      .then((res) => { if (active) setMeta(res.data); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!meta || !meta.last_reviewed_at) return null;

  const d = new Date(meta.last_reviewed_at);
  const label = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });

  return (
    <div className="mt-10 pt-6 border-t border-border flex items-start gap-3 text-xs text-muted-foreground" data-testid="legal-compliance-stamp">
      <ShieldCheck className="h-4 w-4 mt-0.5 text-emerald-600 shrink-0" />
      <p>
        Dernière vérification de conformité automatique : <strong>{label}</strong>.
        Ces textes font l'objet d'une revue mensuelle automatisée au regard du droit français en vigueur (RGPD, loi Informatique et Libertés, loi 1901, Code général des impôts, Code de la consommation).
      </p>
    </div>
  );
};

export default LegalComplianceStamp;
